import { Component, inject, QueryList, ViewChildren } from '@angular/core';
import { ServiceNavTileComponent } from '../../components/service-nav-tile/service-nav-tile.component';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';
import { PUBLIC_MARKETING_RUNTIME_CONFIG } from '../../tokens/public-marketing-runtime.token';
import { ViewDidLeave, ViewWillEnter } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  codeSlashOutline,
  gridOutline,
  mapOutline,
  personAddOutline,
  rocketOutline,
} from 'ionicons/icons';

addIcons({
  gridOutline,
  mapOutline,
  codeSlashOutline,
  personAddOutline,
  rocketOutline,
});

@Component({
  selector: 'app-about-project',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent, ServiceNavTileComponent],
  templateUrl: './about-project.component.html',
  styleUrls: ['./about-project.component.css', '../../styles/service-tiles.css'],
})
export class AboutProjectComponent implements ViewWillEnter, ViewDidLeave {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  private readonly marketing = inject(PUBLIC_MARKETING_RUNTIME_CONFIG);

  @ViewChildren(ServiceNavTileComponent) serviceTiles!: QueryList<ServiceNavTileComponent>;

  readonly appSubtitle = this.marketing.appSubtitle;
  readonly pageTitle = 'About';

  ionViewWillEnter(): void {
    this.resetServiceNavTiles();
  }

  ionViewDidLeave(): void {
    this.resetServiceNavTiles();
  }

  private resetServiceNavTiles(): void {
    this.serviceTiles?.forEach((t) => t.resetLoadingState());
  }
}
